// import React, { useEffect } from "react";
// import leaf from "../assets/articale/9.jpg";

// const Discount = () => {



//   function replaceVidPlaceholder() {
//     console.log("Function replaceVidPlaceholder() called.");
  
//     if (window.clickmagick_cmc) {
//       console.log("window.clickmagick_cmc exists:", window.clickmagick_cmc);
  
//       if (window.clickmagick_cmc.vid) {
//         console.log("window.clickmagick_cmc.vid exists:", window.clickmagick_cmc.vid);
  
//         const links = document.querySelectorAll('[href*="[cmc_vid]"]');
//         console.log("Found links with placeholder:", links.length);
  
//         if (links.length > 0) {
//           links.forEach((link) => {
//             console.log("Original href:", link.href);
//             link.href = link.href.replace("[cmc_vid]", window.clickmagick_cmc.vid);
//             console.log("Updated href:", link.href);
//           });
//         }
//       } else {
//         console.log("window.clickmagick_cmc.vid is not defined yet.");
//       }
//     } else {
//       console.log("window.clickmagick_cmc is not defined yet.");
//     }
  
//     if (!window.clickmagick_cmc || !window.clickmagick_cmc.vid) {
//       console.log("Retrying in 200ms...");
//       setTimeout(replaceVidPlaceholder, 200);
//     }
//   }
//   useEffect(() => {
//     console.log("User landed on page. Calling replaceVidPlaceholder...");
//     replaceVidPlaceholder();
//   }, []);

//   return (
//     <div>
//       <h2 className="text-xl font-bold text-gray-800 mb-6">
//         <span className=" font-bold underline text-center flex justify-center">
//           {"Get an Exclusive “Breathe” Discount Now!"}
//         </span>
//       </h2>
//       <div className="relative w-full mb-6">
//         <img
//           src={leaf}
//           alt="Lung diagram with surrounding bacterial images"
//           className="w-full rounded-3xl border boder-gay-100"
//           draggable="false"
//         />
//       </div>
//       <div className="space-y-4 text-[#303030]">
//         <p className="text-center">
//           <span className="font-bold text-center w-fit bg-[#ffbf00]">
//             <i>{"40% OFF + FREE SHIPPING – LIMITED TIME ONLY!"}</i>{" "}
//           </span>
//         </p>
//         <p className=" text-center border-2 border-dashed border-[#ff0000] rounded-md p-4">
//           {
//             "This campaign is only available for the first 200 customers. Don’t wait—"
//           }
//           <span className="font-bold">{"act now"}</span>
//           {" before it's too late!"}
//           <span className="font-bold">{" Click to Get Your "}</span>{" "}
//           <a
//             href="https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=[cmc_vid]"
//             target="_blank"
//             rel="noopener noreferrer"
//             className="font-bold text-blue-600 hover:underline"
//           >
//             {" 40% OFF “Breathe” Now!"}{" "}
//           </a>
//         </p>
//         <div className="flex justify-center my-5">
//           <div className="flex justify-center my-5">
//             <a
//               href="https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=[cmc_vid]"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <button className="bg-[#ff9900] text-white px-6 py-4 rounded-md flex items-center space-x-3 ease-in-out transition hover:translate-y-[2px] hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90">
//                 <span className="text-lg font-semibold">
//                   {"GET Herbal Tea Therapy Breathe NOW"}
//                 </span>
//                 <span className="text-xl">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="white"
//                   >
//                     <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
//                   </svg>
//                 </span>
//               </button>
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Discount;



























import React, { useEffect, useState } from "react";
import leaf from "../assets/articale/9.jpg";

const Discount = () => {
  const [vid, setVid] = useState(null);
  useEffect(() => {
    function replaceVidPlaceholder() {
      if (window?.clickmagick_cmc && window?.clickmagick_cmc?.vid) {
        setVid(window?.clickmagick_cmc?.vid);
      } else {
        setTimeout(replaceVidPlaceholder, 200);
      }
    }
    replaceVidPlaceholder();
  }, []);

  return (
    <div>
      <h2 className="text-xl font-bold text-gray-800 mb-6">
        <span className=" font-bold underline text-center flex justify-center">
          {"Get an Exclusive “Breathe” Discount Now!"}
        </span>
      </h2>
      <div className="relative w-full mb-6">
        <img
          src={leaf}
          alt="Lung diagram with surrounding bacterial images"
          className="w-full rounded-3xl border boder-gay-100"
          draggable="false"
        />
      </div>
      <div className="space-y-4 text-[#303030]">
        <p className="text-center">
          <span className="font-bold text-center w-fit bg-[#ffbf00]">
            <i>{"40% OFF + FREE SHIPPING – LIMITED TIME ONLY!"}</i>{" "}
          </span>
        </p>
        <p className=" text-center border-2 border-dashed border-[#ff0000] rounded-md p-4">
          {
            "This campaign is only available for the first 200 customers. Don’t wait—"
          }
          <span className="font-bold">{"act now"}</span>
          {" before it's too late!"}
          <span className="font-bold">{" Click to Get Your "}</span>{" "}
          {vid ? (
            <a
              id="cta-button"
              href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
              rel="noopener noreferrer"
              className="font-bold text-blue-600 hover:underline"
            >
              {"40% OFF “Breathe” Now!"}{" "}
            </a>
          ) : (
            <a
              id="cta-button"
              href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}

              rel="noopener noreferrer"
              className="font-bold text-blue-600 hover:underline"
            >
              {"40% OFF “Breathe” Now!"}{" "}
            </a>
          )}
        </p>
        <div className="flex justify-center my-5">
          <div className="flex justify-center my-5">
            {vid ? (
              <a
                id="cta-button"
                href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
                rel="noopener noreferrer"
              >
                <button className="bg-[#ff9900] text-white px-6 py-4 rounded-md flex items-center space-x-3 ease-in-out transition hover:translate-y-[2px] hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90">
                  <span className="text-lg font-semibold">
                    {"GET Herbal Tea Therapy Breathe NOW"}
                  </span>
                  <span className="text-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                    </svg>
                  </span>
                </button>
              </a>
            ) : (
              <a id="cta-button" rel="noopener noreferrer"
              href={`https://specialoffer.breatheagain.io/?aff=HerbalTeaTherapy&cid=${vid}`}
              >
                <button className="bg-[#ff9900] text-white px-6 py-4 rounded-md flex items-center space-x-3 ease-in-out transition hover:translate-y-[2px] hover:bg-[#ff9900] hover:shadow-sm hover:bg-opacity-90">
                  <span className="text-lg font-semibold">
                    {"GET Herbal Tea Therapy Breathe NOW"}
                  </span>
                  <span className="text-xl">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707" />
                    </svg>
                  </span>
                </button>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discount;
